"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetDestinationProjects = void 0;
var vizportal_webclient_api_1 = require("@tableau/vizportal-webclient-api");
var GetDestinationProjectsMethod_1 = require("@tableau/vizportal-webclient-api/lib/api/methods/GetDestinationProjectsMethod");
var VizportalApi_1 = require("./VizportalApi");
var GetDestinationProjects = /** @class */ (function (_super) {
    __extends(GetDestinationProjects, _super);
    function GetDestinationProjects() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GetDestinationProjects.getProjects = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var projects = new Array();
            _this.GetDestinatonProjectsItems(0, function (newProjects) {
                projects = projects.concat(newProjects);
            }, function () {
                resolve(projects);
            }, function () {
                reject(projects);
            });
        });
    };
    GetDestinationProjects.GetDestinatonProjectsItems = function (startIdx, onProjectsAdded, onComplete, onError) {
        var _this = this;
        var contentType = 'predictiveModel';
        var params = new GetDestinationProjectsMethod_1.GetDestinationProjectParams(contentType, startIdx);
        var getDestinationProjects = this.getVizportalWebClientRequester().createSender(GetDestinationProjectsMethod_1.GetDestinationProjectsMethod);
        void getDestinationProjects(params).then(function (resp) {
            if (!vizportal_webclient_api_1.WebClientResponseHelper.isErrorResponse(resp)) {
                var result = resp.response.result;
                onProjectsAdded(result.projects);
                if (!result.moreItems) {
                    onComplete();
                }
                else {
                    _this.GetDestinatonProjectsItems(startIdx + result.projects.length, onProjectsAdded, onComplete, onError);
                }
            }
            else {
                onError();
            }
        }),
            function (error) {
                console.error('Error getting project: ', error);
            };
    };
    return GetDestinationProjects;
}(VizportalApi_1.VizportalApiService));
exports.GetDestinationProjects = GetDestinationProjects;
//# sourceMappingURL=GetDestinationProjects.js.map